<template>
  <div class="add-professional-page">
    <div class="filter-box">
      <el-input
        v-model="listQuery.title"
        clearable
        round
        placeholder="请输入关键字"
        style="width: 172px"
        class="filter-item"
      />
      <Btn
        btnText="搜索"
        className="primary"
        :fontSize="14"
        :width="72"
        :height="40"
        class="filter-item"
        @handleClick="getList()"
      />
      <Btn
        btnText="添加"
        className="primary_plain"
        :fontSize="14"
        :width="103"
        :height="37"
        class="create-btn"
        @handleClick="handCreate"
      />
      <!-- <Btn
        btnText="导出excel"
        className="primary_plain"
        :fontSize="14"
        :width="103"
        :height="40"
        @handleClick="handlerExport()"
      /> -->
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column label="机构ID" align="center" prop="businessInfoId" />
      <el-table-column label="机构名称" prop="businessName" align="center">
      </el-table-column>
      <el-table-column label="机构类型" align="center" prop="secondaryType">
        <template slot-scope="scope">
          <span>{{ scope.row.secondaryType | typeFilter }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="机构描述" prop="businessDescribe">
      </el-table-column> -->
      <el-table-column label="邮箱" align="center" prop="email" />
      <el-table-column label="帐号" align="center" prop="username" />
      <el-table-column label="联系人姓名" align="center" prop="name" />
      <el-table-column label="联系电话" align="center" prop="phone" />
      <el-table-column
        label="用户状态"
        width="120"
        align="center"
        prop="status"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.status === "0" ? "离职" : "在职" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <div class="handle-box">
            <el-link type="primary" @click="handDetail(scope.row.id)"
              >详情</el-link
            >
            <el-link type="primary" @click="handUpdate(scope.row.id)"
              >修改</el-link
            >
            <el-link type="primary" @click="handResetPsw(scope.row.id)"
              >重置密码</el-link
            >
            <el-link type="primary" @click="handleDel(scope.row.id)"
              >删除</el-link
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-if="total > 0"
      :total="total"
      :page.sync="listQuery.current"
      :limit.sync="listQuery.size"
      class="no-print"
      @pagination="getList"
    />

    <el-dialog title="重置密码" :visible.sync="dialogResetPsw" width="400px">
      <el-form ref="form" :model="form" :rules="formRules" label-width="90px">
        <el-form-item label="新密码" prop="password">
          <el-input v-model="form.password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogResetPsw = false">取 消</el-button>
        <el-button type="primary" @click="resetPsw">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { list, del, reset } from "@/api/agency";
// import { optionsFilter, parseTime } from "@/utils";
import Btn from "../../components/Btn.vue";
import Pagination from "../../components/Pagination.vue";
export default {
  components: { Btn, Pagination },
  // filters: { optionsFilter, parseTime},
  filters: {
    typeFilter(status) {
      const statusMap = {
        NON_ACADEMIC_EDUCATION: "非学历教育",
        ACADEMIC_EDUCATION: "学历教育",
        EMPLOYER: "用人单位"
      };
      return statusMap[status];
    }
  },
  data() {
    return {
      listLoading: false,
      listQuery: {
        status: undefined,
        startDate: undefined,
        current: 1,
        size: 10
      },
      list: [],
      total: 0,
      typeMap: {
        NON_ACADEMIC_EDUCATION: "非学历教育",
        ACADEMIC_EDUCATION: "学历教育",
        EMPLOYER: "用人单位"
      },
      form: {},
      dialogResetPsw: false,
      formRules: {
        password: [{ required: true, message: "不能为空", trigger: "change" }]
      }

      // statusOptions: [
      //   // {
      //   //   label: '所有状态',
      //   //   value: undefined
      //   // },
      //   {
      //     label: "已处理",
      //     value: "PROCESSED"
      //   },
      //   {
      //     label: "待处理",
      //     value: "WAIT"
      //   }
      // ],
      // sexOptions,
      // studentStatusOptions,
      // checkStatusOptions
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      list(this.listQuery).then(res => {
        this.list = res.data.d.records;
        this.total = res.data.d.total;
      });
    },
    async handlerExport() {
      const excel = await import("@/vendor/Export2Excel");
      const tHeader = [
        "机构ID",
        "机构名称",
        "机构类型",
        "机构描述",
        "邮箱",
        "帐号",
        "联系人姓名",
        "联系电话",
        "用户状态"
      ];
      const filterVal = [
        "businessInfoId",
        "businessName",
        "secondaryType",
        "businessDescribe",
        "email",
        "username",
        "name",
        "phone",
        "status"
      ];
      const listData = await list({ ...this.listQuery, size: 999999 }).then(
        res => res.data.d.records
      );
      const data = this.formatJson(filterVal, listData);
      excel.export_json_to_excel({
        header: tHeader,
        data: data,
        filename: "帐号列表"
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          let value;
          if (j === "secondaryType") {
            value = this.typeMap[v[j]];
          } else if (j === "status") {
            value = v[j] === 0 ? "离职" : "在职";
          } else {
            value = v[j];
          }
          return value;
        })
      );
    },
    handCreate() {
      this.$router.push({ path: "staffDetail", query: { type: "add" } });
    },
    handDetail(id) {
      this.$router.push({ path: "staffDetail", query: { type: "detail", id } });
    },
    handUpdate(id) {
      this.$router.push({ path: "staffDetail", query: { type: "update", id } });
    },
    handleDel(id) {
      this.$_confirm({
        message: "确定要删除该帐号吗？",
        confirm: () => {
          del({ id }).then(res => {
            this.$_message({
              message: "删除成功!"
            });
            this.getList();
          });
        }
      });
    },
    handResetPsw(id) {
      // this.form = Object.assign({}, row);
      this.$nextTick(() => {
        this.$refs.form.resetFields();
      }, 100);
      this.form = {
        id,
        password: undefined
      };
      this.dialogResetPsw = true;
    },
    resetPsw() {
      this.$refs.form.validate(valid => {
        if (valid) {
          reset(this.form).then(res => {
            if (res.data.c === 200) {
              this.dialogResetPsw = false;
              this.$message.success("重置成功");
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-box {
  margin-bottom: 23px;
}
.upload-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .hint-box {
    display: flex;
    align-items: center;
    .hint {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #6e6e6e;
      display: flex;
      align-items: center;
      margin-right: 15px;
      cursor: pointer;
      img {
        width: 14px;
        height: 14px;
        margin-right: 6px;
      }
    }
    .btn {
      margin-right: 10px;
    }
  }
}
.failed {
  color: #ff5129;
}
.handle-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.create-btn {
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/educational/staffList.vue